import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import Avatar from 'components/Avatar';
import Message from 'components/Message';
import messages from './ReservationFeedbackModalV2.messages';

import './UserProfile.scss';

const { block, element } = bem('user-profile');

const UserProfile = ({ fullName, profileUrl }) => {
  return (
    <div className={block()}>
      <Message className={element('label')} message={messages.reportingLabel} />
      <div className={element('info')}>
        <Avatar size={20} name={fullName} url={profileUrl} />
        <div className={element('name')}>{fullName}</div>
      </div>
    </div>
  );
};

UserProfile.propTypes = {
  fullName: PropTypes.string.isRequired,
  profileUrl: PropTypes.string,
};

export default UserProfile;
